
import Swiper from 'swiper/swiper-bundle.min'
import StoryblokComponent from '~/components/Storyblok/Component'
import breakpointMixin from '~/mixins/breakpoints'
import { Gradient } from '~/assets/js/gradient'
import 'swiper/swiper-bundle.min.css'

export default {
  components: {
    StoryblokComponent,
  },
  mixins: [breakpointMixin],
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      locationText: 'Long Beach, CA',
      locationDate: 'MAY 7 – 9',
    }
  },
  computed: {
    backgroundStyles() {
      const styles = {}

      const imgUrl = this.$img(this.blok.gradientBG?.filename, {
        format: 'webp',
        preload: true,
      })
      styles.background = `url('${imgUrl}') no-repeat center center`
      styles.backgroundSize = 'cover'

      return styles
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.initMarquee()
      // media query context
      const mm = this.$gsap.matchMedia(this.$refs.container)

      // executes desktop only - lg breakpoint
      mm.add('(min-width: 1024px)', () => {
        if (this.blok.toggleAnimation) {
          this.initGradient()
        }

        this.initAnimation()
      })
    })
  },
  methods: {
    initGradient() {
      // // Create your instance
      const gradient = new Gradient()

      // // Call `initGradient` with the selector to your canvas
      gradient.initGradient('#gradient-canvas')
    },
    initMarquee() {
      this.swiperInstance = new Swiper(this.$refs.swiper, {
        slidesPerView: 4,
        breakpoints: {
          // when window width is >= 320px
          320: {
            slidesPerView: 4,
          },
          // when window width is >= 640px
          768: {
            slidesPerView: 6,
          },
          1280: {
            slidesPerView: 8,
          },
        },
        loop: true,
        // effect: 'cards',
        // cssMode: true,

        freeMode: true,
        // spaceBetween: Number(this.blok?.spaceBetween) ?? 30,
        grabCursor: true,
        keyboard: true,

        speed: 800,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
      })
    },
    initAnimation() {
      this.$gsap.from(this.$refs.header, {
        scale: 0.8,
        duration: 0.8,
      })
      // const split = new this.$SplitText('.RechargeAspot--header', {
      //   type: 'lines,words,chars',
      //   linesClass: 'overflow-hidden',
      // })
      // console.log(split)
      // this.$gsap.from(split.chars, {
      //   y: 50,
      //   stagger: 0.05,
      //   delay: 0.2,
      //   duration: 0.1,
      // })
      // this.$gsap.set(['.aspot-img'], {
      //   opacity: 0,
      //   scale: 0.9,
      //   transformOrigin: 'center center',
      // })
      // this.$gsap.to(['.aspot-img'], {
      //   opacity: 1,
      //   scale: 1,
      //   // y: 0,
      //   duration: 0.8,
      //   stagger: 0.3,
      //   delay: 0.3,
      // })
    },
  },
}
